import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { waLink } from "@/lib/api";

export const Footer = () => {
  const { settings } = useStore();
  return (
    <footer className="bg-espresso text-bone" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-24 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <p className="font-serif text-4xl md:text-5xl leading-tight mb-4">
            Healthy, glowing skin<br />
            <span className="italic text-terracotta">starts here.</span>
          </p>
          <p className="text-bone/60 max-w-sm">{settings.tagline || "Safe skincare for radiant skin."}</p>
        </div>
        <div>
          <p className="overline text-bone/50 mb-5">Explore</p>
          <ul className="space-y-3">
            {[
              { to: "/shop", label: "Shop" },
              { to: "/learn", label: "Learn" },
              { to: "/reviews", label: "Reviews" },
              { to: "/track", label: "Track Order" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-bone/80 hover:text-terracotta transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline text-bone/50 mb-5">Help &amp; Legal</p>
          <ul className="space-y-3">
            {[
              { to: "/policies/shipping", label: "Shipping & Delivery" },
              { to: "/policies/refund", label: "Refund Policy" },
              { to: "/policies/terms", label: "Terms of Service" },
              { to: "/policies/privacy", label: "Privacy Policy" },
              { to: "/policies/disclaimer", label: "Skincare Disclaimer" },
              { to: "/policies/cookies", label: "Cookie Notice" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.to.split("/").pop()}`} className="text-bone/80 hover:text-terracotta transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline text-bone/50 mb-5">Reach us</p>
          <ul className="space-y-3 text-bone/80">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-terracotta" /> {settings.phone}
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-terracotta mt-1" /> {settings.location}
            </li>
            <li className="flex gap-4 pt-2">
              <a href={settings.instagram || "#"} target="_blank" rel="noreferrer" aria-label="Instagram">
                <Instagram className="w-5 h-5 hover:text-terracotta transition-colors" />
              </a>
              <a href={waLink(settings.whatsapp, "Hi 17/11 BeautyBarn!")} target="_blank" rel="noreferrer" className="hover:text-terracotta transition-colors">
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-5 md:px-10 flex flex-col md:flex-row justify-between gap-2 text-bone/40 text-sm max-w-7xl mx-auto">
        <span>© {new Date().getFullYear()} 17/11 BeautyBarn. All rights reserved.</span>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/policies/terms" className="hover:text-bone/70 transition-colors" data-testid="footer-terms">Terms</Link>
          <Link to="/policies/privacy" className="hover:text-bone/70 transition-colors" data-testid="footer-privacy">Privacy</Link>
          <Link to="/policies/refund" className="hover:text-bone/70 transition-colors" data-testid="footer-refund">Refunds</Link>
          <Link to="/policies/shipping" className="hover:text-bone/70 transition-colors" data-testid="footer-shipping">Shipping</Link>
          <Link to="/policies/disclaimer" className="hover:text-bone/70 transition-colors" data-testid="footer-disclaimer">Disclaimer</Link>
          <Link to="/policies/cookies" className="hover:text-bone/70 transition-colors" data-testid="footer-cookies">Cookies</Link>
        </div>
      </div>
    </footer>
  );
};
